import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
export var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  text-align: left;\n  background: inherit;\n  justify-content: ", ";\n"], ["\n  display: flex;\n  text-align: left;\n  background: inherit;\n  justify-content: ",
    ";\n"])), function (props) {
    return props.textAlignment === 'left' ? 'flex-start' : 'flex-end';
});
export var CellContent = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  box-sizing: border-box;\n  padding: 15px 20px;\n  flex-direction: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  box-sizing: border-box;\n  padding: 15px 20px;\n  flex-direction: ",
    ";\n"])), function (_a) {
    var textAlignment = _a.textAlignment;
    return textAlignment === 'left' ? 'row' : 'row-reverse';
});
var templateObject_1, templateObject_2;
